var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox relative" },
    [
      _c(
        "el-card",
        {
          directives: [
            {
              name: "hasPermi",
              rawName: "v-hasPermi",
              value: ["platform:order:page:list"],
              expression: "['platform:order:page:list']",
            },
          ],
          staticClass: "ivu-mt",
          attrs: {
            bordered: false,
            shadow: "never",
            "body-style": { padding: 0 },
          },
        },
        [
          _c(
            "div",
            { staticClass: "padding-add" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    size: "small",
                    inline: "",
                    "label-position": "right",
                  },
                  nativeOn: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单编号：", "label-width": "66px" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: {
                          placeholder: "请输入订单编号",
                          size: "small",
                          clearable: "",
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleSearchList($event)
                          },
                        },
                        model: {
                          value: _vm.tableFrom.orderNo,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.tableFrom,
                              "orderNo",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "tableFrom.orderNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单类型：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: {
                            clearable: "",
                            size: "small",
                            placeholder: "请选择",
                          },
                          on: { change: _vm.handleSearchList },
                          model: {
                            value: _vm.tableFrom.type,
                            callback: function ($$v) {
                              _vm.$set(_vm.tableFrom, "type", $$v)
                            },
                            expression: "tableFrom.type",
                          },
                        },
                        _vm._l(_vm.fromType, function (item, i) {
                          return _c("el-option", {
                            key: i,
                            attrs: { label: item.text, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "时间选择：" } },
                    [
                      _c("el-date-picker", {
                        staticClass: "selWidth",
                        attrs: {
                          "value-format": "yyyy-MM-dd",
                          format: "yyyy-MM-dd",
                          size: "small",
                          type: "daterange",
                          placement: "bottom-end",
                          placeholder: "自定义时间",
                        },
                        on: { change: _vm.onchangeTime },
                        model: {
                          value: _vm.timeVal,
                          callback: function ($$v) {
                            _vm.timeVal = $$v
                          },
                          expression: "timeVal",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "用户搜索：", "label-for": "nickname" } },
                    [
                      _c("UserSearchInput", {
                        model: {
                          value: _vm.tableFrom,
                          callback: function ($$v) {
                            _vm.tableFrom = $$v
                          },
                          expression: "tableFrom",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商户名称：" } },
                    [
                      _c("merchant-name", {
                        attrs: { merIdChecked: _vm.tableFrom.merId },
                        on: { getMerId: _vm.getMerId },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商户类型：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: {
                            clearable: "",
                            size: "small",
                            placeholder: "请选择",
                          },
                          model: {
                            value: _vm.tableFrom.isFu,
                            callback: function ($$v) {
                              _vm.$set(_vm.tableFrom, "isFu", $$v)
                            },
                            expression: "tableFrom.isFu",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "福豆商家", value: "1" },
                          }),
                          _c("el-option", {
                            attrs: { label: "积分商家", value: "0" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "small" },
                          on: { click: _vm.handleSearchList },
                        },
                        [_vm._v("查询")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: { click: _vm.handleReset },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-card",
        {
          staticClass: "box-card mt14",
          attrs: {
            "body-style": { padding: "0 20px 20px" },
            shadow: "never",
            bordered: false,
          },
        },
        [
          _c(
            "el-tabs",
            {
              staticClass: "list-tabs",
              on: { "tab-click": _vm.handleSearchList },
              model: {
                value: _vm.tableFrom.status,
                callback: function ($$v) {
                  _vm.$set(_vm.tableFrom, "status", $$v)
                },
                expression: "tableFrom.status",
              },
            },
            [
              _c("el-tab-pane", {
                attrs: {
                  name: "all",
                  label: "全部(" + (_vm.orderChartType.all || 0) + ")",
                },
              }),
              _c("el-tab-pane", {
                attrs: {
                  name: "unPaid",
                  label: "未支付(" + (_vm.orderChartType.unPaid || 0) + ")",
                },
              }),
              _c("el-tab-pane", {
                attrs: {
                  name: "notShipped",
                  label: "未发货(" + (_vm.orderChartType.notShipped || 0) + ")",
                },
              }),
              _c("el-tab-pane", {
                attrs: {
                  name: "spike",
                  label: "待收货(" + (_vm.orderChartType.spike || 0) + ")",
                },
              }),
              _c("el-tab-pane", {
                attrs: {
                  name: "awaitVerification",
                  label:
                    "待核销(" + (_vm.orderChartType.verification || 0) + ")",
                },
              }),
              _c("el-tab-pane", {
                attrs: {
                  name: "receiving",
                  label: "已收货(" + (_vm.orderChartType.receiving || 0) + ")",
                },
              }),
              _c("el-tab-pane", {
                attrs: {
                  name: "complete",
                  label: "已完成(" + (_vm.orderChartType.complete || 0) + ")",
                },
              }),
              _c("el-tab-pane", {
                attrs: {
                  name: "refunded",
                  label: "已退款(" + (_vm.orderChartType.refunded || 0) + ")",
                },
              }),
              _c("el-tab-pane", {
                attrs: {
                  name: "cancel",
                  label: "已取消(" + (_vm.orderChartType.cancel || 0) + ")",
                },
              }),
              _c("el-tab-pane", {
                attrs: {
                  name: "deleted",
                  label: "已删除(" + (_vm.orderChartType.deleted || 0) + ")",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "mt5" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: ["platform:export:order:excel"],
                      expression: "['platform:export:order:excel']",
                    },
                  ],
                  attrs: { size: "small" },
                  on: { click: _vm.exports },
                },
                [_vm._v("导出")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "mt20",
              attrs: {
                data: _vm.tableData.data,
                size: "small",
                "highlight-current-row": "",
                "row-key": function (row) {
                  return row.orderNo
                },
              },
            },
            [
              _vm.checkedCities.includes("订单编号")
                ? _c("el-table-column", {
                    attrs: { label: "订单编号", "min-width": "220" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "acea-row" },
                                [
                                  _c(
                                    "font",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: scope.row.type === 1,
                                          expression: "scope.row.type === 1",
                                        },
                                      ],
                                      staticClass: "mr5",
                                    },
                                    [_vm._v("[秒杀]")]
                                  ),
                                  _c(
                                    "font",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: scope.row.type === 2,
                                          expression: "scope.row.type === 2",
                                        },
                                      ],
                                      staticClass: "mr5",
                                    },
                                    [_vm._v("[拼团]")]
                                  ),
                                  _c("span", {
                                    staticStyle: { display: "block" },
                                    domProps: {
                                      textContent: _vm._s(scope.row.orderNo),
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "flex" }, [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          parseInt(scope.row.refundStatus) > 0,
                                        expression:
                                          "parseInt(scope.row.refundStatus) > 0",
                                      },
                                    ],
                                    staticClass: "colorPrompt",
                                    staticStyle: { display: "block" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("orderRefundStatusFilter")(
                                          scope.row.refundStatus
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: scope.row.refundStatus == 2,
                                        expression:
                                          "scope.row.refundStatus == 2",
                                      },
                                    ],
                                    staticClass: "colorPrompt",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        "（已退款 " +
                                          scope.row.refundNum +
                                          " / 购买 " +
                                          scope.row.totalNum +
                                          "）"
                                      )
                                    ),
                                  ]
                                ),
                              ]),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: scope.row.isUserDel,
                                      expression: "scope.row.isUserDel",
                                    },
                                  ],
                                  staticClass: "colorPrompt",
                                  staticStyle: { display: "block" },
                                },
                                [_vm._v("用户已删除")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2986503998
                    ),
                  })
                : _vm._e(),
              _vm.checkedCities.includes("商户名称")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "merName",
                      label: "商户名称",
                      "min-width": "150",
                    },
                  })
                : _vm._e(),
              _vm.checkedCities.includes("商品信息")
                ? _c("el-table-column", {
                    attrs: { label: "商品信息", "min-width": "200" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.productList &&
                              scope.row.productList.length
                                ? _c(
                                    "div",
                                    { staticClass: "order-product-list" },
                                    _vm._l(
                                      scope.row.productList,
                                      function (product, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticClass: "order-product-item",
                                          },
                                          [
                                            _c("img", {
                                              staticClass: "product-image",
                                              attrs: { src: product.image },
                                              on: {
                                                error: function ($event) {
                                                  product.image = ""
                                                },
                                              },
                                            }),
                                            _c(
                                              "div",
                                              { staticClass: "product-info" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "product-name",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        product.productName ||
                                                          "-"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "product-spec",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        product.specName ||
                                                          "默认规格"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "product-quantity",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "x" +
                                                        _vm._s(product.quantity)
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "product-price" },
                                              [
                                                _vm._v(
                                                  "¥" + _vm._s(product.price)
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _c("span", [_vm._v("-")]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1656604938
                    ),
                  })
                : _vm._e(),
              _vm.checkedCities.includes("物流信息")
                ? _c("el-table-column", {
                    attrs: { label: "物流信息", "min-width": "250" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.invoiceList &&
                              scope.row.invoiceList.length > 0
                                ? _c(
                                    "div",
                                    _vm._l(
                                      scope.row.invoiceList,
                                      function (invoice, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticClass: "invoice-item",
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "express-name" },
                                              [
                                                _vm._v(
                                                  _vm._s(invoice.expressName)
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "tracking-number",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onOrderDetails(
                                                      scope.row.orderNo,
                                                      "delivery"
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      invoice.trackingNumber
                                                    ) +
                                                    " "
                                                ),
                                                _c("i", {
                                                  staticClass: "el-icon-view",
                                                }),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _c("span", { staticClass: "no-logistics" }, [
                                    _vm._v("暂无物流"),
                                  ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3247535942
                    ),
                  })
                : _vm._e(),
              _vm.checkedCities.includes("用户昵称")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "nickName",
                      label: "用户昵称",
                      "min-width": "150",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "span",
                                {
                                  class:
                                    scope.row.isLogoff == true
                                      ? "colorPrompt"
                                      : "",
                                },
                                [_vm._v(_vm._s(scope.row.nickName))]
                              ),
                              scope.row.isLogoff == true
                                ? _c(
                                    "span",
                                    {
                                      class:
                                        scope.row.isLogoff == true
                                          ? "colorPrompt"
                                          : "",
                                    },
                                    [_vm._v("|")]
                                  )
                                : _vm._e(),
                              scope.row.isLogoff == true
                                ? _c("span", { staticClass: "colorPrompt" }, [
                                    _vm._v("(已注销)"),
                                  ])
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      755995446
                    ),
                  })
                : _vm._e(),
              _vm.checkedCities.includes("收货信息")
                ? _c("el-table-column", {
                    attrs: { label: "收货信息", "min-width": "150" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.realName
                                ? _c("div", [
                                    _c("div", [
                                      _vm._v(_vm._s(scope.row.realName)),
                                    ]),
                                    _c("div", [
                                      _vm._v(_vm._s(scope.row.userPhone)),
                                    ]),
                                    _c("div", { staticClass: "address-text" }, [
                                      _vm._v(_vm._s(scope.row.userAddress)),
                                    ]),
                                  ])
                                : _c("div", { staticClass: "colorPrompt" }, [
                                    _vm._v("暂无收货信息"),
                                  ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3254741813
                    ),
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { prop: "isFu", label: "商户类型", "min-width": "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", { staticClass: "spBlock" }, [
                          _vm._v(
                            _vm._s(
                              scope.row.isFu == 1 ? "福豆商家" : "积分商家"
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "useType",
                  label: "抵用方式",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", { staticClass: "spBlock" }, [
                          _vm._v(
                            _vm._s(scope.row.useType == 1 ? "抵用券" : "福豆")
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm.checkedCities.includes("实际支付")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "payPrice",
                      label: "实际支付",
                      "min-width": "80",
                    },
                  })
                : _vm._e(),
              _vm.checkedCities.includes("支付方式")
                ? _c("el-table-column", {
                    attrs: { label: "支付方式", "min-width": "80" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [_vm._v(_vm._s(scope.row.payType))]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2086191382
                    ),
                  })
                : _vm._e(),
              _vm.checkedCities.includes("订单状态")
                ? _c("el-table-column", {
                    attrs: { label: "订单状态", "min-width": "100" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.refundStatus === 3
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "textE93323 tag-background notStartTag tag-padding",
                                    },
                                    [_vm._v("已退款")]
                                  )
                                : scope.row.groupBuyRecordStatus == 99 ||
                                  scope.row.status == 9 ||
                                  scope.row.groupBuyRecordStatus == 10
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "tag-background tag-padding",
                                      class:
                                        scope.row.status < 5
                                          ? "doingTag"
                                          : "endTag",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("orderStatusFilter")(
                                            scope.row.status
                                          )
                                        )
                                      ),
                                    ]
                                  )
                                : _c(
                                    "span",
                                    {
                                      staticClass:
                                        "textE93323 tag-background notStartTag tag-padding",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.groupBuyRecordStatus == 0
                                            ? "拼团中"
                                            : "拼团失败"
                                        )
                                      ),
                                    ]
                                  ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3808130961
                    ),
                  })
                : _vm._e(),
              _vm.checkedCities.includes("付款凭证")
                ? _c("el-table-column", {
                    attrs: { label: "付款凭证", "min-width": "100" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm.parsePaymentImg(scope.row.paymentImg).length
                                ? _c(
                                    "div",
                                    { staticClass: "acea-row row-middle" },
                                    _vm._l(
                                      _vm
                                        .parsePaymentImg(scope.row.paymentImg)
                                        .slice(0, 2),
                                      function (url, idx) {
                                        return _c("el-image", {
                                          key: idx,
                                          staticClass: "mr5 pictrue-small",
                                          attrs: {
                                            src: url,
                                            "preview-src-list":
                                              _vm.parsePaymentImg(
                                                scope.row.paymentImg
                                              ),
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  )
                                : _c("span", [_vm._v("-")]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      4055521994
                    ),
                  })
                : _vm._e(),
              _vm.checkedCities.includes("拒绝原因")
                ? _c("el-table-column", {
                    attrs: {
                      label: "拒绝原因",
                      "min-width": "120",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                " " + _vm._s(scope.row.repulseCase || "-") + " "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      4160178060
                    ),
                  })
                : _vm._e(),
              _vm.checkedCities.includes("下单时间")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "createTime",
                      label: "下单时间",
                      "min-width": "140",
                    },
                  })
                : _vm._e(),
              _vm.checkPermi(["platform:order:info"])
                ? _c(
                    "el-table-column",
                    {
                      attrs: { width: "70", fixed: "right" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.groupBuyRecordStatus != 0
                                  ? _c(
                                      "a",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.onOrderDetails(
                                              scope.row.orderNo
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(" 详情")]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1204385721
                      ),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("p", [
                          _c(
                            "span",
                            { staticStyle: { "padding-right": "5px" } },
                            [_vm._v("操作")]
                          ),
                          _c("i", {
                            staticClass: "el-icon-setting",
                            on: { click: _vm.handleAddItem },
                          }),
                        ]),
                      ]),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "page-sizes": [20, 40, 60, 80],
                  "page-size": _vm.tableFrom.limit,
                  "current-page": _vm.tableFrom.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.card_select_show,
              expression: "card_select_show",
            },
          ],
          staticClass: "card_abs",
        },
        [
          [
            _c(
              "div",
              { staticClass: "cell_ht" },
              [
                _c(
                  "el-checkbox",
                  {
                    attrs: { indeterminate: _vm.isIndeterminate },
                    on: { change: _vm.handleCheckAllChange },
                    model: {
                      value: _vm.checkAll,
                      callback: function ($$v) {
                        _vm.checkAll = $$v
                      },
                      expression: "checkAll",
                    },
                  },
                  [_vm._v("全选")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "text" },
                    on: {
                      click: function ($event) {
                        return _vm.checkSave()
                      },
                    },
                  },
                  [_vm._v("保存")]
                ),
              ],
              1
            ),
            _c(
              "el-checkbox-group",
              {
                on: { change: _vm.handleCheckedCitiesChange },
                model: {
                  value: _vm.checkedCities,
                  callback: function ($$v) {
                    _vm.checkedCities = $$v
                  },
                  expression: "checkedCities",
                },
              },
              _vm._l(_vm.columnData, function (item) {
                return _c(
                  "el-checkbox",
                  {
                    key: item,
                    staticClass: "check_cell",
                    attrs: { label: item },
                  },
                  [_vm._v(_vm._s(item))]
                )
              }),
              1
            ),
          ],
        ],
        2
      ),
      _c("details-from", {
        ref: "orderDetail",
        attrs: { orderNo: _vm.orderNo },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }